import React, { useRef, useState } from "react";


export default function VolumeBar({ volume, setVolume, colorTheme, sliderBg }) {

    const [isDragging, setDragging] = useState(false)
    const progressRef = useRef()

    const handleMouseDown = (e) => {
        setDragging(true)
    };
    const handleVolSliderClick = (e) => {
        let progressBar = progressRef.current
        const { left, width } = progressBar.getBoundingClientRect();
        const clickX = e.clientX - left; // Position of click relative to the bar
        const newVolume = Math.round(((clickX * 100) / width));
        if (newVolume <= 100 && newVolume >= 0) {
            if (newVolume < 5)
                setVolume(0)
            else
                setVolume(newVolume / 100)
        }
    }
    const handleMouseUp = (e) => {
        setDragging(false)
    };
    const handleMouseMove = (e) => {
        let progressBar = progressRef.current
        // Get container dimensions and position
        const containerRect = progressBar.getBoundingClientRect();
        const prevVolume = volume
        // Calculate the position of the cursor relative to the container
        const mouseX = e.clientX - containerRect.left;

        // Clamp the position between 0 and the width of the container
        const newVolume = Math.max(0, Math.min(mouseX, containerRect.width)) * 100 / 80;
        if (Math.abs(prevVolume - (newVolume / 100)) > 0.05
            && newVolume <= 100 && newVolume >= 0) {
            if (newVolume < 5)
                setVolume(0)
            else
                setVolume(newVolume / 100)
        }
    };
    return (
        <div
            ref={progressRef}
            onMouseMove={isDragging ? handleMouseMove : null}
            onTouchMove={isDragging ? handleMouseMove : null}
            onMouseDown={handleMouseDown}
            onTouchStart={handleMouseDown}
            onMouseLeave={handleMouseUp}
            onMouseUp={handleMouseUp}
            onTouchEnd={handleMouseUp}
            onClick={handleVolSliderClick}
            style={{ background: sliderBg }}
            className={"relative rounded-full h-[5px] mx-2 cursor-pointer w-[80px]"}
        >
            <div
                className={"h-[5px] rounded-full "} style={{ background: colorTheme, width: `${volume * 100}%` }}></div>
            <div
                className={"absolute w-3 h-3 rounded-full transform -translate-x-1/2 -translate-y-1/2 shadow-sm" + (isDragging ? " w-[14px] h-[14px] " : "")}
                style={{ left: `${volume * 100}%`, top: "45%", background: colorTheme, }}
            ></div>
        </div>
    )
}